// Job types offered in the New/Edit Job menu (also used by the Daily Field Report SOW / Job Type dropdowns)
export const JOB_TYPES = ["OCALC", "DMG", "ABF", "BAU", "ASE", "PBB", "SEAL", "SV", "CELL SITE", "PFP", "F1", "F2", "ACB"];
